'use strict';

var _merge = require('lodash/object/merge');

var _merge2 = _interopRequireDefault(_merge);

var _fecha = require('fecha');

var _fecha2 = _interopRequireDefault(_fecha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
*/

module.exports = function (data) {
    return {
        'data': data.snapshots.map(serializeSnapshot),
        'guid': data.id
    };
};

/**
*/

function serializeSnapshot(snapshot) {

    var signerFields = [];
    var groups = {};
    var fields = snapshot.fields;

    fields.forEach(function (field, i) {
        if (field.type === 'group') {

            var groupName = 'group' + i;
            field.children.forEach(function (child) {
                child.group = groupName;
                signerFields.push(child);
            });

            groups[groupName] = 'required_' + (field.validate.min || 0) + '-' + (field.validate.max || 'ormore');
        } else if (field.signer !== void 0 && field.signer !== null) {
            signerFields.push(field);
        }
    });

    // Ensures ordering is kept
    signerFields = signerFields.sort(function (a, b) {
        return a.order > b.order ? 1 : -1;
    });

    return {
        'guid': snapshot.guid,
        'data': signerFields.map(serializeField),
        'signers': [],
        'signer_names': null,
        'order_map': null,
        'ccs': [],
        'groups': groups,
        'merge_fields': []
    };
}

/**
*/

function serializeField(field) {

    var serializers = {
        'def': serializeDefaultField,
        'signature': serializeSignatureField,
        'initials': serializeSignatureField,
        'checkbox': serializeCheckboxField,
        'date': serializeDateField,
        'text': serializeTextField
    };

    return (0, _merge2['default'])(serializers.def(field), serializers[field.type] ? serializers[field.type](field) : {}, serializeFieldType(field));
}

/**
*/

function serializeSignatureField(field) {
    // NOTE: The back-end expects '' when it's not been filled in
    // see HFOverlayUtils::overlaySigOrInitials()
    return {
        'data': {
            'imgSrc': field.value ? '/attachment/view?sig_guid=' + field.value : ''
        }
    };
}

/**
*/

function serializeCheckboxField(field) {
    return {
        'data': {
            'checked': field.value || false,
            'group': field.group
        }
    };
}

/**
*/

function serializeDateField(field) {
    return {
        'data': {
            'fontSize': field.fontSize,
            'content': _fecha2['default'].format(new Date(field.value), 'MM / DD / YYYY')
        }
    };
}

/**
*/

function serializeTextField(field) {
    return {
        'data': {
            'content': field.value ? field.value.trim() : null,
            'validation_type': field.validationType || null
        }
    };
}

/**
*/

function serializeDefaultField(field) {
    return {
        'data': {
            'id': field.id,
            'width': field.width,
            'height': field.height,
            'required': field.required,
            'api_id': field.apiId || 'api',
            'fontSize': field.fontSize,
            'lineHeight': field.lineHeight,
            'padding': field.padding
        },
        'x': field.x,
        'y': field.y,
        'z': 500
    };
}

/**
*/

function serializeFieldType(field) {
    return {
        componentType: {
            'signature': 'inputsignature',
            'date': 'inputdate',
            'initials': 'inputinitials',
            'text': 'inputtextbox',
            'checkbox': 'inputcheckmark'
        }[field.type]
    };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/signer/api/endpoints/serialize-signature-request.js
 ** module id = 587
 ** module chunks = 0
 **/